import { useMemo } from 'react';
import { useMantineTableWithPaginationFilteringSorting } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting.ts';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { getLoansTableColumns } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/Loans/components/LoansTable/getLoansTableColumns.tsx';
import { DataLoanDefinitionTct } from '@dealstack/shared/lib/generated';
import { useSecurityTypeTranslation } from '@dealstack/frontend/shared/translationControllers/useCommonTranslationsController.ts';

interface LoanFilterDto {
	type?: string[];
	name?: string;
	funder?: string;
}

interface Props {
	onEdit: (loan: DataLoanDefinitionTct) => void;
}

export const useLoansTableState = ({ onEdit }: Props) => {
	const tMipManage = useTranslationMipManage();
	const getSecurityTypeTranslation = useSecurityTypeTranslation();

	const columns = useMemo(
		() =>
			getLoansTableColumns({
				tMipManage,
				getSecurityTypeTranslation,
				handlers: { onEdit },
			}),
		[tMipManage, getSecurityTypeTranslation, onEdit]
	);

	const initialTableOptions = {
		initialSorting: [{ id: 'createdAt', desc: false }],
	};

	const { mantineTableDataOperations } = useMantineTableWithPaginationFilteringSorting<
		DataLoanDefinitionTct,
		LoanFilterDto
	>(columns, initialTableOptions, false);

	return {
		columns,
		mantineTableDataOperations,
	};
};
